import logo from '../assets/images/logo.svg'

const Logo = () => {
  return <img width="160" height="120" viewBox="0 0 160 120" src={logo} alt='bassin cotyl' className='logo' />
}

export default Logo
